"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsEan = void 0;
const class_validator_1 = require("class-validator");
const IsNumeric_decorator_1 = require("../generic/IsNumeric.decorator");
const combineDecorators_1 = require("../utils/combineDecorators");
/**
 * Validates on the following properties:
 * - string
 * - is numeric
 * - Length of 12 to 18
 * ## Valid Example
 * `871689290401467626`
 */
const IsEan = () => (0, combineDecorators_1.combineDecorators)((0, class_validator_1.IsString)(), (0, IsNumeric_decorator_1.IsNumeric)(), (0, class_validator_1.MinLength)(12), (0, class_validator_1.MaxLength)(18));
exports.IsEan = IsEan;
